{
  "common": {
    "login": "Login",
    "error": "An error occurred",
    "goHome": "Go Home",
    "loading": "Loading..."
  },
  "pages": {
    "login": {
      "pageTitle": "Login"
    },
    "notFound": {
      "message": "Page not found",
      "title": "Oops"
    },
    "dashboard": {
      "title": "Widget Items",
      "createButton": "New Widget Item",
      "noData": "No items found",
      "columns": {
        "name": "Name",
        "description": "Description",
        "status": "Status",
        "createdOn": "Created On"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "createTitle": "Create Widget Item",
      "form": {
        "name": "Name",
        "description": "Description",
        "isActive": "Active",
        "nameRequired": "Name is required."
      }
    }
  }
}
